const util = {
  methods: {
    Format: function (fmt = "yyyy-MM-dd HH:mm:ss") {
      let o = {
        "M+": this.getMonth() + 1, // 月份
        "d+": this.getDate(), // 日
        "h+": this.getHours(), // 小时
        "m+": this.getMinutes(), // 分
        "s+": this.getSeconds(), // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
        S: this.getMilliseconds(), // 毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
    addDay(date, n) {
      return add(date, n, "day");
    },
    addHour(date, n) {
      return add(date, n, "hour");
    },
    addMinute(date, n) {
      return add(date, n, "minute");
    },
    addSecond(date, n) {
      return add(date, n, "second");
    },
    //获取前后的时间,n可为负数和小数
    add(date, n, unit) {
      if (!date) {
        return null;
      }
      if (typeof date === "string") {
        date = date.replace(/-/g, "/");
      }
      // let million_second = 0;
      switch (unit) {
        case "day":
          unit = 1000 * 60 * 60 * 24;
          break;
        case "hour":
          unit = 1000 * 60 * 60;
          break;
        case "minute":
          unit = 1000 * 60;
          break;
        case "second":
          unit = 1000;
          break;
      }
      return new Date(date.getTime() + n * unit);
    },
  },
};
/**
 * 超级常用的工具类
 */
export default util;
export const format = util.methods.format;
export const add = util.methods.add;
export const addDay = util.methods.addDay;
export const addMinute = util.methods.addMinute;
export const addSecond = util.methods.addSecond;
